import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../mock';
import { Card, CardContent } from './ui/card';

const Testimonials = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <span className="text-amber-600 font-semibold text-sm uppercase tracking-wide">Mišljenja klijenata</span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mt-4 mb-6">
            Što kažu naši klijenti
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            Ponos nam je što smo zadobili povjerenje mnogih zadovoljnih klijenata
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <Card key={testimonial.id} className="border-gray-200 hover:shadow-xl transition-shadow duration-300">
              <CardContent className="pt-6">
                <div className="mb-4">
                  <Quote className="text-amber-600" size={32} />
                </div>
                
                <div className="flex mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="text-amber-500 fill-amber-500" size={18} />
                  ))}
                </div>
                
                <p className="text-gray-700 mb-6 leading-relaxed">
                  "{testimonial.text}"
                </p>
                
                <div className="border-t pt-4">
                  <p className="font-semibold text-gray-900">{testimonial.name}</p>
                  <p className="text-sm text-gray-600">{testimonial.company}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;